import { singleton } from 'tsyringe';
import { IUipTranslation } from '../models';

const relativeDictionaryUrl = '/public-api/dictionaries/uip';

/** 
 * Base dictionary URL. Either absent or an absolute URL.
 * @remarks The variable will be assigned during top-menu export flow.
 */
declare var baseDictionaryUrl: string;

@singleton()
export class UipTranslationService {
  private _translations?: Promise<IUipTranslation>;

  public get translations(): Promise<IUipTranslation> {
    return this._translations ? this._translations : this._translations = this.getTranslations();
  }

  private async getTranslations(): Promise<IUipTranslation> {
    const langInPath = document.documentElement.dataset.langInPath;
    const marketLocale = `/${document.documentElement.dataset.marketLocale}`;
    const dictionaryUrl = typeof baseDictionaryUrl === 'string' ? baseDictionaryUrl : '';

    const shouldAppendLocale = langInPath === "true" && !dictionaryUrl.endsWith(marketLocale);
    const languagePrefix = shouldAppendLocale ? marketLocale : '';

    const requestUrl = `${baseDictionaryUrl}${languagePrefix}${relativeDictionaryUrl}`;
    const translationsResponse: Response = await fetch(requestUrl).catch(() => null);
    const translations = translationsResponse && translationsResponse.ok ? await translationsResponse.json() : {};

    return translations;
  }
}
